/*eslint-disable */
var define = window.define || ace.define;

define('mode/markddrive', function(require, exports, module) {

  var oop = require("ace/lib/oop");
  var MarkdownMode = require("ace/mode/markdown").Mode;
  var PythonMode = require("ace/mode/python").Mode;
  var PHPMode = require("ace/mode/php").Mode;
  var RubyMode = require("ace/mode/ruby").Mode;
  var MarkdDriveHighlightRules = require("markddrive_highlight_rules").MarkdDriveHighlightRules;

  var Mode = function() {
    this.HighlightRules = MarkdDriveHighlightRules;

    this.createModeDelegates({
      "python-": PythonMode,
      "php-": PHPMode,
      "ruby-": RubyMode
    });

    this.$behaviour = this.$defaultBehaviour;
  };
  oop.inherits(Mode, MarkdownMode);

  (function() {
    // Extra logic goes here. (see below)
  }).call(Mode.prototype);

  exports.Mode = Mode;
});

define('markddrive_highlight_rules', function(require, exports, module) {

  var oop = require("ace/lib/oop");
  var MarkdownHighlightRules = require("ace/mode/markdown_highlight_rules").MarkdownHighlightRules;
  var PHPHighlightRules = require("ace/mode/php_highlight_rules").PhpHighlightRules;
  var PythonHighlightRules = require("ace/mode/python_highlight_rules").PythonHighlightRules;
  var RubyHighlightRules = require("ace/mode/ruby_highlight_rules").RubyHighlightRules;

  function github_embed(tag, prefix) {
    return { // Github style block
      token : "support.function",
      regex : "^\\s*```" + tag + "\\s*$",
      push  : prefix + "start"
    };
  }

  var MarkdDriveHighlightRules = function() {

    this.$rules = new MarkdownHighlightRules().getRules();

    var unnumeredListRule = { // unnumbered list
      token : function(indent, list_item) {
        var tabSize = window._session.getTabSize();
        return ["markup.list", "markup.list.unnumbered.level_" + (indent.length / tabSize)];
      },
      regex : "^(\\s{0,})([*+-]\\s+)",
      next  : "listblock-start"
    };
    var numberedListRule = {// numbered list
      token : function(indent, list_item) {
        var tabSize = window._session.getTabSize();
        return ["markup.list", "markup.list.numbered.level_" + (indent.length / tabSize)];
      },
      regex : "^(\\s{0,})(\\d+\\.\\s+)",
      next  : "listblock-start"
    };

    this.$rules["start"].unshift(
        github_embed("php", "phpcode-"),
        github_embed("python", "pythoncode-"),
        github_embed("ruby", "rubycode-"),
        unnumeredListRule,
        numberedListRule,
    );

    this.addRules({
      "listblock" : [
        { // Lists only escape on completely blank lines.
          token : "empty_line",
          regex : "^$",
          next  : "start"
        },
        unnumeredListRule,
        numberedListRule,
        {
          include : "basic", noEscape: true
        },
        { // Github style block
          token : "support.function",
          regex : "^\\s*```\\s*[a-zA-Z]*(?:{.*?\\})?\\s*$",
          next  : "githubblock"
        },
        {
          defaultToken : "list" //do not use markup.list to allow stling leading `*` differntly
        }
      ],
    });

    this.embedRules(PHPHighlightRules, "phpcode-", [{
      token : "support.function",
      regex : "^\\s*```",
      next  : "pop"
    }]);

    this.embedRules(PythonHighlightRules, "pythoncode-", [{
      token : "support.function",
      regex : "^\\s*```",
      next  : "pop"
    }]);

    this.embedRules(RubyHighlightRules, "rubycode-", [{
      token : "support.function",
      regex : "^\\s*```",
      next  : "pop"
    }]);

    this.normalizeRules();
  }

  oop.inherits(MarkdDriveHighlightRules, MarkdownHighlightRules);

  exports.MarkdDriveHighlightRules = MarkdDriveHighlightRules;
});
/*eslint-enable */



// WEBPACK FOOTER //
// ./src/ace_custom/mode-markddrive.js